import { Pipe, PipeTransform } from '@angular/core';

/** "Acme Holdings Ltd" -> "AH"; falls back to "?". */
@Pipe({ name: 'initials' })
export class InitialsPipe implements PipeTransform {
  transform(value: string | null | undefined): string {
    const parts = String(value || '').trim().split(/\s+/).filter(Boolean);
    if (!parts.length) return '?';
    return ((parts[0][0] || '') + (parts[1]?.[0] || '')).toUpperCase();
  }
}
